import { useEffect, useRef } from "react";
import * as styles from "./enzymeBrownRice.css";
import conceptImage from "../../../../assets/Concept/hatugakousogenmaigohan.jpg";
import { useNavigate } from "react-router-dom";

export const EnzymeBrownRice = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const target = entry.target as HTMLElement;
          if (entry.isIntersecting) {
            target.style.opacity = "1";
            target.style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.1 }
    );

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => {
      if (contentRef.current) {
        observer.unobserve(contentRef.current);
      }
    };
  }, []);

  return (
    <div className={styles.container}>
      <div ref={contentRef} className={styles.content}>
        <div className={styles.imageWrapper}>
          <img
            src={conceptImage}
            alt="酵素玄米"
            className={styles.image}
            style={{ width: "100%", height: "auto", objectFit: "contain" }}
          />
        </div>
        <div className={styles.textContent}>
          <h2 className={styles.title}>酵素玄米について</h2>
          <p className={styles.description}>
          当店で提供している酵素玄米プレートのご飯は発芽酵素玄米です

          <h3>発芽酵素玄米とは</h3>
          玄米をわずかに発芽させ小豆と一緒に炊いて３日間熟成（保温）させる事で酵素が活性化、玄米のままより栄養価が高く甘みが増してぬか部分も柔らかくなるためふっくらもちもち食感、消化・吸収に優れ身体に優しいご飯です。

<br/>
          主な効能：腸内環境を整え便秘解消・大腸がん予防・免疫力を高める・血圧調整・コレステロール改善・貧血の改善・肝、腎、脳の劣化防止・美肌効果・ストレス軽減・リラックス効果など
<h3>白米よりなぜ玄米？</h3>
白米は精米の過程で胚芽や糠(ぬか)といった部分が取り除かれてしまうためビタミン、ミネラルなどの栄養素が玄米に比べて大幅に少なく、腸内環境を整え便秘解消や
生活習慣病予防に役立つ食物繊維も少なく不足しがちになります。<br/>
また玄米に比べ消化吸収が早く、腹持ちが悪いため食後すぐに空腹を感じやすいことや食後の血糖値が急上昇しやすく、インスリンの過剰分泌を招き、脂肪の蓄積や糖尿病の
リスクを高める可能性があるため玄米の方が優れています。

<h3>玄米のデメリットは？</h3>
１ 食物繊維が豊富＝消化に時間がかかり消化不良を起こしやすい<br/>
２ 農薬の残留リスク<br/>
３ フィチン酸によるミネラル吸収阻害<br/>
玄米に含まれるフィチン酸は、鉄、亜鉛、カルシウムなどのミネラルと結合し体への吸収を阻害する可能性があると言われています

<h3>KitchenMükü発芽酵素玄米のメリット</h3>

１ 玄米より消化・吸収が良いので胃腸への負担が少ない！<br/>
２ 使用している玄米は長沼町ファームキトラさんが手間を掛け作られた安心の無農薬無化学肥料玄米で残留農薬の心配なし！<br/>
３ 玄米を発芽させ長時間浸水させてから炊くことでフィチン酸を分解しているためミネラル吸収阻害のリスクを軽減!        
          </p>
          <span
            className={styles.backLink}
            onClick={() => navigate('/')}
            role="link"
            tabIndex={0}
            style={{ cursor: 'pointer' }}
          >
            トップへ戻る
          </span>
        </div>
      </div>
    </div>
  );
}; 